<script setup lang="ts">
import { computed, ref, watch } from "vue";
import {
  EyeIcon,
  EyeOffIcon
} from "@lucide/vue"

const props = defineProps({
  id: {
    type: String,
    required: true
  },
  name: {
    type: String,
    default: "password"
  },
  modelValue: {
    type: String,
  },
  class: {
    type: String,
    default: ""
  },
  inputClass: {
    type: String,
    default: ""
  },
  isInvalid: {
    type: Boolean,
    default: false
  },
  required: {
    type: Boolean,
    default: false
  },
  autocomplete: {
    type: String,
    default: "off"
  }
});

const password = ref(props.modelValue)
watch(
  () => props.modelValue,
  (val) => {
    password.value = val;
  }
)


const showPassword = ref(false);
const toggleVisibility = function() {
  showPassword.value = !showPassword.value;
};

const inputType = computed(() => {
  return showPassword.value ? "text" : "password";
});

</script>

<template>
  <div class="input-group mb-2" :class="[
    props.class,
    { 'is-invalid': props.isInvalid },
  ]">
    <input :type="inputType"
           v-model="password"
           v-bind="$attrs"
           :name="props.name"
           :id="props.id"
           class="form-control"
           :class="[
             props.inputClass,
             { 'is-invalid': props.isInvalid },
           ]"
           :autocomplete="props.autocomplete"
           :required="props.required">
    <div class="input-group-append">
      <button
        type="button"
        class="input-group-text"
        @click="toggleVisibility"
      >
        <template v-if="showPassword">
          <EyeIcon class="tw:w-4 tw:h-4" />
        </template>
        <template v-else>
          <EyeOffIcon class="tw:w-4 tw:h-4" />
        </template>
      </button>
    </div>
  </div>
</template>

<style scoped>

</style>